<template>
  <div>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null,null)">添加</el-button>
      </el-form-item>

      <el-form-item>
        <el-date-picker
          v-model="createTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{background:'#F4F4F5',color:'#606266'}"
      @selection-change="handleSelectionChange"
      border
    >
      <!-- <el-table-column
            label="选择"
            prop="orderid"
            type="selection"
            :show-overflow-tooltip="true"
            width="50"
            align="center"
      />-->
      <el-table-column type="selection" width="50" fixed/>
      <el-table-column label="标签名称" prop="usersearchname" align="center"/>
      <el-table-column label="修改时间" prop="usersearchtime" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.usersearchtime != null">
            <i class="el-icon-time"></i>
            {{
            scope.row.usersearchtime | formatDateStr("yyyy-MM-dd hh:mm:ss")
            }}
          </span>
          <span v-if="scope.row.usersearchtime == null">-</span>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleForm(scope.$index,scope.row)"
          >修改</el-button>
          <el-button
            type="danger"
            size="mini"
            @click.native="handleDel(scope.row.usersearchname)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
      </transition>
    </div>

    <el-pagination
      class="pagination-container"
      background
      :page-size="query.pageSize"
      :current-page="query.currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>
    <!--修改-->
    <el-dialog
      :title="forMap[formName]"
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="800px"
      top="5vh"
      v-dialogDrag
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item label="标签名称:" prop="usersearchname">
          <el-input v-model="formData.usersearchname" clearable></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
    getUserSearchList,
    add,
    deleteSearch
} from "../../api/product/brand.js";
const formJson = {
    brandid: "",
    brandurl: "",
    brandtitle: "",
    brandsort: ""
};

export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近六个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 180
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },

            moneyreward: "",
            ordercategory: "",
            dialogImageUrl: "",
            dialogVisible: false,
            cancelToggle: false,
            servicestarttime: [],
            createTime: [],
            query: {
                brandtitle: "",
                currentPage: 1,
                pageSize: 10
            },
            list: [],
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            forMap: {
                add: "添加",
                edit: "编辑"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {
                usersearchname: {
                    required: true,
                    message: "请输入标签名称",
                    trigger: "blur"
                }
            },
            multipleSelection: [] //多选集合
        };
    },

    methods: {
        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
            }
            this.getUserSearchList();
        },

        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        delGroup() {
            var usersearchnames = this.multipleSelection
                .map(item => item.usersearchname)
                .join(); //获取所有选中行的id组成的字符串，以逗号分隔
            if (usersearchnames == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning"
                });
                return;
            }
            this.handleDel(usersearchnames);
        },
        onRest() {
            this.query = {
                startTime: "",
                endTime: "",
                currentPage: 1,
                pageSize: 10
            };
            this.createTime = [];
            this.getUserSearchList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getUserSearchList();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            //scrollTo(0, 800);
            this.getUserSearchList();
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getUserSearchList();
        },
        handleAvatarSuccess(res, file) {
            this.formData.brandurl = res.data;
            console.info(res);
            console.info(file);
        },
        getUserSearchList() {
            this.loading = true;
            getUserSearchList(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }

                    this.list = response.data.list || [];
                    this.totalNumber = response.data.totalNumber || 0;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.totalNumber = 0;
                });
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            return true;
        },
        hideFormAdd() {
            // 更改值
            this.formInput = !this.formInput;
            return true;
        },

        hideFormInput() {
            // 更改值
            this.formInput = !this.formInput;
            return true;
        },

        hideInfo() {
            // 更改值
            this.formInfo = !this.formInfo;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            this.$refs.tinymce.clearContent();
            this.query.brandtitle = "";
            return true;
        },
        hideInput() {
            // 更改值
            this.formInput = !this.formInput;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            this.query.brandtitle = "";
            return true;
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
            //编辑
            if (index != null) {
                this.index = index;
                this.formName = "edit";
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        formSubmit() {
            delete this.formData.userid;
            delete this.formData.usersearchtime;
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    var params = new URLSearchParams(this.formData);
                    add(params).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        // 刷新表单
                        this.$refs["dataForm"].resetFields();
                        //this.$refs.tinymce.clearContent();
                        this.formVisible = false;
                        this.getUserSearchList();
                    });
                }
            });
        },
        // 删除
        handleDel(usersearchnames) {
            if (usersearchnames) {
                this.$confirm("确认要删除吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.loading = true;
                        var params = new URLSearchParams();
                        params.append("usersearchnames", usersearchnames);
                        deleteSearch(params)
                            .then(response => {
                                this.loading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("删除成功");
                                // 刷新数据
                                //this.list.splice(index, 1);
                                this.getUserSearchList();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        }
    },
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        // 加载表格数据
        this.getUserSearchList();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
</style>
